import {cn} from '../lib/cn';

export type StepperProps = {
  totalSteps: number;
  activeStep: number;
  className?: string;
  cumulative?: boolean;
};

export function Stepper({
  totalSteps,
  activeStep,
  className,
  cumulative = false,
}: StepperProps) {
  if (totalSteps <= 0) return null;

  const clampedActiveStep = Math.max(1, Math.min(totalSteps, activeStep));

  return (
    <div
      className={cn('flex w-full items-center gap-2', className)}
      role="progressbar"
      aria-valuemin={1}
      aria-valuemax={totalSteps}
      aria-valuenow={clampedActiveStep}
    >
      {new Array(totalSteps).fill(null).map((_, stepIndex) => {
        const stepNumber = stepIndex + 1;
        const isActive = cumulative
          ? stepNumber <= clampedActiveStep
          : stepNumber === clampedActiveStep;

        return (
          <span
            key={stepNumber}
            className={cn(
              'h-1.5 min-h-px min-w-px flex-1 rounded-[1000px] bg-[var(--chekin-color-gray-3)]',
              isActive && 'bg-[var(--chekin-color-brand-blue)]',
            )}
          />
        );
      })}
    </div>
  );
}
